import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesAnnualCosts from '../../Utilities/UtilitiesEstimatedAnnualCost/UtilitiesAnnualCosts';
import { HEATING_OIL } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HeatingOilAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={HEATING_OIL.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Heating oil"
      knowAnnualCostsUtilityProviderField={HEATING_OIL.FIELD_NAME.KNOW_ANNUAL_COSTS_UTILITY_PROVIDER}
    />
  );
}

export default HeatingOilAnnualCosts;
